module.exports = __webpack_public_path__ + "img/图片2.22f6acb7.png";